module.exports = __webpack_public_path__ + "img/coins.a0bd7191.svg";